import { FusaReply } from "@/types/replyTypes";
import { Client } from "./client";
import { VersionType } from "@/types/genericVersionTypes";
import { ProcedureVersionResponse, ProcedureVersionsResponse } from "@/backend/express/controllers/procedureVersionController";

export class ProcedureVersionController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  public async delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/procedure-versions/${id}`);
  }

  public async publish(versionId: string, procedureId: string, versionType: VersionType): Promise<ProcedureVersionResponse> {
    return this.client.update(`/api/procedure-versions/publish`, { versionId, procedureId, versionType });
  }

  public async read(id: string): Promise<ProcedureVersionResponse> {
    return this.client.read(`/api/procedure-versions/${id}`);
  }

  public async readAllByProcedureId(procedureId: string): Promise<ProcedureVersionsResponse> {
    return this.client.read(`/api/procedure-versions/by-procedure/${procedureId}`);
  }
}

